import { cva } from 'class-variance-authority';

const SkeletonPulseContentStyles = cva('animate-pulse');

const SkeletonTableHeaderStyles = cva('mb-4 grid grid-cols-3 gap-4 px-4 py-3 border-b border-gray-200');
const SkeletonTableHeaderCellStyles = cva('h-4 bg-gray-200 rounded');
const SkeletonRowsContainerStyles = cva('space-y-3');
const SkeletonRowStyles = cva(
  'rounded-orderImport-upload-section border border-orderImport-upload-section-border p-4 grid grid-cols-3 gap-4 items-center',
);
const SkeletonRowCellStyles = cva('h-4 bg-gray-200 rounded');
const SkeletonRowCellTallStyles = cva('h-12 bg-gray-200 rounded');
const SkeletonButtonContainerStyles = cva('mt-8 flex gap-4 justify-end');
const SkeletonButtonStyles = cva('h-10 bg-gray-200 rounded-lg w-48');

const OrderImportProcessingSkeleton = () => {
  return (
    <div className={SkeletonPulseContentStyles()}>
      <div className={SkeletonTableHeaderStyles()}>
        <div className={SkeletonTableHeaderCellStyles()} />
        <div className={SkeletonTableHeaderCellStyles()} />
        <div className={SkeletonTableHeaderCellStyles()} />
      </div>

      <div className={SkeletonRowsContainerStyles()}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div className={SkeletonRowStyles()} key={index}>
            <div className={SkeletonRowCellTallStyles()} />
            <div className={SkeletonRowCellStyles()} />
            <div className={SkeletonRowCellStyles()} />
          </div>
        ))}
      </div>

      <div className={SkeletonButtonContainerStyles()}>
        <div className={SkeletonButtonStyles()} />
        <div className={SkeletonButtonStyles()} />
      </div>
    </div>
  );
};

export default OrderImportProcessingSkeleton;
